// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app.scss
// module id = 441
// module chunks = 0